// Yönetici rol → bölüm eşlemesi (backend governance.py ile aynı mantık; asıl yetki kontrolü sunucudadır)
export function areaOfRoute(path) {
  const p = path.replace(/^\/admin\/?/, "");
  const first = p.split("/")[0];
  if (first === "") return "dashboard";
  if (["accounting"].includes(first)) return "finance";
  if (first === "reports") return "reports";
  if (["site-studio", "media", "shop", "site-features"].includes(first)) return "site";
  if (["security", "users", "governance", "integration"].includes(first)) return "owner";
  if (first === "settings") return "settings";
  if (first === "account") return "common";
  return "ops";
}

export function canSee(user, path) {
  if (!user || user.role !== "admin") return true;
  const a = areaOfRoute(path);
  if (a === "common") return true;
  const areas = user.areas || {};
  if (a === "dashboard") return !!areas.ops;
  return !!areas[a];
}

export function homeFor(user) {
  const a = user?.areas || {};
  if (a.ops) return "/admin";
  if (a.finance) return "/admin/accounting";
  if (a.site) return "/admin/site-studio";
  return "/admin/account";
}

export const ROLE_LABELS = { owner: "Sahip", manager: "Müdür", accounting: "Muhasebe", operations: "Operasyon", site_editor: "Site editörü" };
